module.exports = {
	"id": "GW",
	"name": "Guinea-Bissau",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.03336,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02502,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.04587,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.02502,
			"20": null,
			"21": 0.00834,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.22101,
			"26": 0.03336,
			"27": 0.02502,
			"28": 0.01668,
			"29": null,
			"30": 0.02502,
			"31": null,
			"32": 0.01668,
			"33": 0.18348,
			"34": 0.00834,
			"35": 0.00417,
			"36": 0.02502,
			"37": 0.00417,
			"38": null,
			"39": 0.01251,
			"40": 0.19599,
			"41": null,
			"42": 0.01251,
			"43": 1.2927,
			"44": 0.03753,
			"45": 0.09591,
			"46": 0.05838,
			"47": 0.11676,
			"48": 0.06255,
			"49": 0.90489,
			"50": 0.5838,
			"51": 0.20433,
			"52": 0.26688,
			"53": 13.26894,
			"54": 2.03496,
			"55": 0.00834,
			"56": 0.01668,
			"57": null
		},
		"firefox": {
			"2": 0.05004,
			"3": 0.14595,
			"4": 0.01251,
			"5": null,
			"6": null,
			"7": 0.01251,
			"8": 0.02502,
			"9": 0.00417,
			"10": 0.01251,
			"11": 0.01668,
			"12": 0.01668,
			"13": 0.00834,
			"14": 0.00834,
			"15": 0.26271,
			"16": 0.01251,
			"17": 0.00834,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.02502,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.01668,
			"30": 0.01668,
			"31": 0.02085,
			"32": 0.01251,
			"33": 0.21267,
			"34": 0.05838,
			"35": 0.01668,
			"36": 0.02502,
			"37": 0.05004,
			"38": 0.00834,
			"39": 0.07089,
			"40": 0.0417,
			"41": 0.01251,
			"42": null,
			"43": 0.43368,
			"44": 0.03336,
			"45": 0.02502,
			"46": 0.11676,
			"47": 1.56792,
			"48": 1.21347,
			"49": 8.10231,
			"50": 0.27105,
			"51": null,
			"52": null,
			"3.5": 0.00417,
			"3.6": 0.00834
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.32526,
			"35": null,
			"36": 0.46704,
			"37": 0.01668,
			"38": null,
			"39": 0.00417,
			"40": 0.15846,
			"41": 0.00417,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.02085,
			"6": null,
			"7": null,
			"8": 0.01251,
			"9": 0.01251,
			"10": 0.13761,
			"3.1": null,
			"3.2": null,
			"5.1": 0.20433,
			"6.1": null,
			"7.1": null,
			"9.1": 0.05838
		},
		"ios_saf": {
			"8": 0,
			"10": 1.34283949459,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0361879705454,
			"8.1-8.4": 0.066855742194,
			"9.0-9.2": 0.0318944825146,
			"9.3": 0.486595310158
		},
		"android": {
			"3": 0,
			"4": 0.128207875969,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0160259844961,
			"4.1": 0.462464124031,
			"4.2-4.3": 1.15616031008,
			"4.4": 2.65115572093,
			"4.4.3-4.4.4": 2.6740499845
		},
		"ie": {
			"6": null,
			"7": 0.0126787283237,
			"8": 0.498696647399,
			"9": 0.109882312139,
			"10": 0.557864046243,
			"11": 3.2077182659,
			"5.5": null
		},
		"op_mob": {
			"0": 1.39769579178,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.038824883105
		},
		"edge": {
			"12": 0.28773,
			"13": 0.17514,
			"14": 0.49206
		},
		"ie_mob": {
			"10": 0.126431830986,
			"11": 0.514758169014
		},
		"bb": {
			"7": 0.00437175,
			"10": null
		},
		"samsung": {
			"0": 3.806337
		},
		"and_uc": {
			"0": 2.745459
		},
		"op_mini": {
			"0": 18.8309123251
		},
		"and_chr": {
			"0": 21.705189
		},
		"and_ff": {
			"0": 1.043391
		}
	},
	"total": 98.86412775
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GW.json
 ** module id = 540
 ** module chunks = 0
 **/